module.exports = __webpack_public_path__ + "img/lair-roof-construction.ffea1879.jpeg";